import React from 'react';

import { WizardSteps, WizardTransitionType } from '@portals/framework';

import { ChooseProductStep } from './choose-product-step/ChooseProductStep';
import { PaymentSettingsStep } from './payment-settings-step/PaymentSettingsStep';
import { StepId, StoreListingWizardContext } from './types';

export const STEPS_MAP: WizardSteps<StoreListingWizardContext, StepId> = {
  [StepId.ChooseProduct]: {
    id: StepId.ChooseProduct,
    isFinalStep: false,
    component: <ChooseProductStep />,
    [WizardTransitionType.Next]: {
      transition: { id: StepId.PaymentSettings },
      isDisabled: ({ contextData }) => !contextData.selectedProduct,
    },
    onTransition: async ({ contextData }) => {
      return !!contextData.selectedProduct;
    },
  },
  [StepId.PaymentSettings]: {
    id: StepId.PaymentSettings,
    isFinalStep: true,
    component: <PaymentSettingsStep />,
    [WizardTransitionType.Prev]: {
      transition: { id: StepId.ChooseProduct },
    },
  },
};
